import {
    AccountBookOutlined,
    CreditCardOutlined,
    HomeOutlined,
    ShoppingCartOutlined, ShoppingOutlined,
    UserOutlined
} from "@ant-design/icons";
import {Link} from 'react-router-dom'

const menus = [
    {
        title: '首页',
        label: <Link to={'/'}>首页</Link>,
        key: '/',
        icon: <HomeOutlined/>,
    },
    {
        title: '用户管理',
        label: '用户管理',
        key: 'user',
        icon: <UserOutlined/>,
        children: [
            {
                title: '用户列表',
                label: <Link to={'/user/userList'}>用户列表</Link>,
                key: '/user/userList',
                // icon: 'user'
            },
            {
                title: '渠道列表',
                label: <Link to={"/user/channelList"}>渠道列表</Link>,
                key: '/user/channelList',
                // icon: 'user'
            }
        ]
    },
    {
        title: '商品管理',
        label: '商品管理',
        key: 'goods',
        icon: <ShoppingOutlined/>,
        children: [
            {
                title: '标准商品',
                label: <Link to={'/goods/goodsList'}>标准商品</Link>,
                key: '/goods/goodsList',
                // icon: 'goods'
            },
            {
                title: '分类管理',
                label: <Link to={'/goods/goodsClassify'}>分类管理</Link>,
                key: '/goods/goodsClassify',
                // icon: 'goods'
            },
            {
                title: '规格管理',
                label: <Link to={'/goods/goodsSku'}>规格管理</Link>,
                key: '/goods/goodsSku',
                // icon: 'goods'
            }
        ]
    },
    {
        title: '团购管理',
        label: '团购管理',
        key: 'group',
        icon: <ShoppingCartOutlined/>,
        children: [
            {
                title: '团购列表',
                label: <Link to={'/group/groupsList'}>团购列表</Link>,
                key: '/group/groupsList',
                // icon: 'group'
            },
            {
                title: '待审核',
                label: <Link to={'/group/groupsExamine'}>待审核</Link>,
                key: '/group/groupsExamine',
                // icon: 'group'
            }
        ]
    },
    {
        title: '订单管理',
        label: '订单管理',
        key: 'order',
        icon: <AccountBookOutlined/>,
        children: [
            {
                title: '订单列表',
                label: <Link to={'/order/ordersList'}>订单列表</Link>,
                key: '/order/ordersList',
                // icon: 'order'
            },
            {
                title: '订单导出',
                label: <Link to={'/order/ordersTiming'}>订单导出</Link>,
                key: '/order/ordersTiming',
            },
            {
                title: '订单报表',
                label: <Link to={'/order/ordersReport'}>订单报表</Link>,
                key: '/order/ordersReport',
                // icon: 'order'
            },
            {
                title: '配送单',
                label: <Link to={'/order/orderDelivery'}>配送单</Link>,
                key: '/order/ordersDelivery',
                // icon: 'order'
            },
            {
                title: '售后管理',
                label: <Link to={'/order/afterSales'}>售后管理</Link>,
                key: '/order/afterSales',
                // icon: 'order'
            },
        ]
    },
    {
        title: '财务管理',
        label: '财务管理',
        key: 'finance',
        icon: <CreditCardOutlined/>,
        children: [
            {
                title: '资产概况',
                label: <Link to={'/finance/list'}>资产概况</Link>,
                key: '/finance/list',
                // icon: 'finance'
            },
            {
                title: '微信商户号',
                label: <Link to={'/finance/merchant'}>微信商户号</Link>,
                key: '/finance/merchant',
                // icon: 'finance'
            }
        ]
    },
];
export default menus;